import { render, staticRenderFns } from "./CustomerSettings.vue?vue&type=template&id=5a2865d3&scoped=true"
import script from "./CustomerSettings.vue?vue&type=script&lang=js"
export * from "./CustomerSettings.vue?vue&type=script&lang=js"
import style0 from "./CustomerSettings.vue?vue&type=style&index=0&id=5a2865d3&prod&lang=scss&scoped=true"
import style1 from "./CustomerSettings.vue?vue&type=style&index=1&id=5a2865d3&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5a2865d3",
  null
  
)

export default component.exports